import { Fragment, useContext, useEffect, useState } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  BellIcon,
  XMarkIcon,
  ShoppingBagIcon,
  UserCircleIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { Context } from "../context/ContextProvider";
import { useParams, useNavigate, useHref } from "react-router-dom";
import instance, { useAxios } from "../api/api";
import Banner from "./Banner";
import Search from "./Search";
import NotificationsNav from "./NotificationsNav";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function NavDisClosure({ changeLanguage, lang, t }) {
  const {
    amountOfItemsInCart,
    newList,
    cartItmes,
    numberInCart,
    company,
    setCompany,
    setOrders,
    isSearch,
    setIsSearch,
    isAskAI,
    setIsAskAI,
    cartCount,
    setCartCount,
    showNotificationsNav,
    setShowNotificationsNav,
  } = useContext(Context);

  const navigation = [
    {
      name: `${t("home")}`,
      href: `/${localStorage.getItem("CN")}`,
      current: true,
    },
    // { name: "حسابي", href: `/profile`, current: false },
    {
      name: `${t("orders")}`,
      href: localStorage.getItem("Token") == null ? `/login` : `/orders`,
      current: false,
    },
    // { name: "Projects", href: `/${localStorage.getItem("CN")}`, current: false },
    //   { name: "Calendar", href: "#", current: false },
  ];
  const navigate = useNavigate();
  const path = useHref();

  const { response, loading, error } = useAxios({
    method: "GET",
    url: `/companies/get-company-name/${
      localStorage.getItem("CN") !== null && localStorage.getItem("CN")
    }`,
    headers: {
      accept: "*/*",
    },
  });

  // const updateCart = async () => {
  //   console.log("here dd .....", localStorage.getItem("OrderId"), cartItmes);
  //   try {
  //     const data = await instance.post("/orders/update", {
  //       _id: localStorage.getItem("OrderId"),
  //       orders: cartItmes,
  //     });
  //     console.log("data :", data);
  //   } catch (error) {
  //     console.log("error: ", error.message);
  //   }
  // };

  useEffect(() => {
    setCompany(response);

  }, []);

  const [isLoading, setIsLoading] = useState(
    localStorage.getItem("Order") != null
  );

  // localStorage.getItem("OrderId") max-w-7xl

  const cartFull =
    localStorage.getItem("Order") != null &&
    JSON.parse(localStorage.getItem("Order")).length > 0
      ? JSON.parse(localStorage.getItem("Order"))
          .filter((p) => p.company_id === response?._id)
          .map((item) => item.qty)
          .reduce((previous, item) => previous + item, 0)
      : 0;

  useEffect(() => {
    // console.log("cart full: ", cartFull);
    if (
      localStorage.getItem("Order") != null &&
      JSON.parse(localStorage.getItem("Order")).length > 0 &&
      cartFull !== 0
    ) {
      setCartCount(cartFull);
    }
  }, [cartCount]);

  const handleNotification = () => {
    setShowNotificationsNav(true);

    setTimeout(() => {
      setShowNotificationsNav(false);
      navigate(`/${localStorage.getItem("CN")}`, {
        shallow: true,
      });
      // JSON.parse(localStorage.getItem("Order")).length === 0 &&
      //   navigate(`/${localStorage.getItem("CN")}`);
    }, 500);
  };

  if (isAskAI) {
    return (
      <Disclosure as="nav" style={{ backgroundColor: "#082032" }}>
        {({ open }) => (
          <>
            <div className="mx-auto px-2 sm:px-6 lg:px-8">
              <div className="relative flex h-16 items-center justify-between">
                <div className="flex flex-1 ">
                  <div className="w-auto  h-8 sm:hidden">
                    <Disclosure.Button className=" rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      ) : (
                        <Bars3Icon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      )}
                    </Disclosure.Button>
                  </div>
                  <img
                    className="h-10 w-auto pt-0  ml-0 rtl:mr-0 "
                    src={require("../images/askai.png")}
                    alt="Your Company"
                  />
                </div>

                <div className="flex flex-1 items-center justify-end">
                  <div className="hidden sm:flex ltr:sm:pr-8 rtl:sm:pl-8">
                    <button
                      onClick={() => changeLanguage(lang)}
                      className="flex items-center text-white"
                    >
                      <img
                        src={
                          lang === "rtl"
                            ? "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
                            : "https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg"
                        }
                        alt=""
                        className="block h-auto w-5 flex-shrink-0"
                      />
                      <span className="ltr:ml-3 rtl:mr-3 block text-sm font-medium">
                        {t("lang")}
                      </span>
                      <span className="sr-only">, change currency</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden">
              <div className="space-y-1 px-2 pb-3 pt-2">
                <div
                  onClick={() => changeLanguage(lang)}
                  className=" text-white block rounded-md px-3 py-2 text-base font-medium "
                >
                  <button
                    // onClick={}
                    className="-m-2 flex items-center p-2 "
                  >
                    <img
                      src={
                        lang === "rtl"
                          ? "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
                          : "https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg"
                      }
                      alt=""
                      className="block h-auto w-5 flex-shrink-0"
                    />
                    <span className="ml-3 rtl:mr-3 block text-base font-medium text-white">
                      {t("lang")}
                    </span>
                    <span className="sr-only">, change currency</span>
                  </button>
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    );
  }

  return (
    <>
      <Banner />
      <Disclosure as="nav" className="bg-black">
        {({ open }) => (
          <>
            <div className="mx-auto px-2 sm:px-6 lg:px-8">
              <div className="relative flex h-16 items-center justify-between">
                <div className="flex flex-1 ">
                  <div className="w-auto  h-8 sm:hidden">
                    <Disclosure.Button className=" rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      ) : (
                        <Bars3Icon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      )}
                    </Disclosure.Button>
                  </div>
                  <h2 className="ml-5 mt-1 rtl:mr-5 text-left rtl:text-right text-2xl sm:text-2xl font-bold text-white">
                    {localStorage.getItem("CN") != null
                      ? localStorage.getItem("CN").toUpperCase()
                      : ""}
                  </h2>
                  {/* <img
                    className="h-10 w-auto pt-0  ml-4 rtl:mr-4 "
                    src={require("../images/logo512.png")}
                    alt="Your Company"
                  /> */}

                  {/* </div> */}
                  <div className="hidden sm:ml-6 sm:block ">
                    <div className="flex space-x-4 space-x-reverse">
                      {navigation.map((item, key) => (
                        <button
                          key={item.name}
                          onClick={async () => {
                            navigate(`${item.href}`);
                          }}
                          className={classNames(
                            path === item.href
                              ? "bg-gray-700 text-white"
                              : "text-gray-300 hover:bg-gray-500 hover:text-white",
                            "rounded-md px-3 py-2 text-sm font-medium mt-0.5 "
                          )}
                          // aria-current={item.current}
                          // aria-current="page"
                          aria-current={path === item.href ? "page" : undefined}
                        >
                          {item.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex flex-1 items-center justify-end">
                  {path === `/${localStorage.getItem("CN")}` ? (
                    <div className=" sm:flex ltr:sm:pr-8 rtl:sm:pl-8 m-8 pt-1 sm:pt-0">
                      <button
                        // onClick={() => changeLanguage(lang)}
                        className="flex items-center text-white"
                      >
                        {/* <img
                        src={
                          lang === "rtl"
                            ? "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
                            : "https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg"
                        }
                        alt=""
                        className="block h-auto w-5 flex-shrink-0"
                      /> */}
                        {/* <span className="ltr:ml-3 rtl:mr-3 block text-sm font-medium">
                        Search
                      </span> */}
                        <MagnifyingGlassIcon
                          className="h-6 w-6 flex-shrink-0  text-white hover:text-blue-400"
                          aria-hidden="true"
                          onClick={() => {
                            setCompany(response);
                            setIsSearch(true);
                          }}
                        />
                        <span className="sr-only">, change currency</span>
                      </button>
                    </div>
                  ) : null}
                  <div className="hidden sm:flex ltr:sm:pr-8 rtl:sm:pl-8">
                    <button
                      onClick={() => changeLanguage(lang)}
                      className="flex items-center text-white"
                    >
                      <img
                        src={
                          lang === "rtl"
                            ? "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
                            : "https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg"
                        }
                        alt=""
                        className="block h-auto w-5 flex-shrink-0"
                      />
                      <span className="ltr:ml-3 rtl:mr-3 block text-sm font-medium">
                        {t("lang")}
                      </span>
                      <span className="sr-only">, change currency</span>
                    </button>
                  </div>

                  {/* Cart */}

                  <div className="ltr:mr-6 rtl:ml-6 flow-root ltr:lg:ml-8 rtl:lg:mr-8">
                    <button
                      onClick={() => {
                        setIsLoading(true);
                        localStorage.getItem("Order") != null &&
                        JSON.parse(localStorage.getItem("Order"))?.length > 0
                          ? navigate("/cart", { shallow: true })
                          : handleNotification();
                      }}
                      className="group -m-2 flex items-center p-2"
                    >
                      <ShoppingBagIcon
                        className="h-6 w-6 flex-shrink-0   text-white hover:text-blue-400 "
                        aria-hidden="true"
                      />
                      {cartCount === 0 &&
                      isLoading &&
                      cartFull === 0 &&
                      localStorage.getItem("Order") != null &&
                      JSON.parse(localStorage.getItem("Order")).length !== 0 ? (
                        <span className="ltr:ml-1 rtl:mr-1 text-sm font-medium w-5  text-white hover:text-blue-400">
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline w-5 h-5 text-white animate-spin rtl:ml-3 ltr:mr-3"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                      ) : (
                        <span className="ltr:ml-1 rtl:mr-1 text-sm font-medium w-5 text-white hover:text-blue-400">
                          {/* {cartFull === 0
                            ? localStorage.getItem("CountCart") != null
                              ? "4"
                              : "55"
                            : cartFull} */}
                          {/* {cartFull} */}
                          {cartFull !== 0 ? cartFull : cartCount}
                        </span>
                      )}
                      <span className="sr-only">items in cart, view bag</span>
                    </button>
                  </div>

                  <div className="ltr:mr-6 rtl:ml-6 flow-root ltr:lg:ml-8 rtl:lg:mr-8">
                    <button
                      // href="/profile"
                      onClick={() => {
                        if (localStorage.getItem("Token") == null) {
                          navigate("/login", { shallow: true });
                        } else {
                          navigate("/profile", { shallow: true });
                        }
                      }}
                      className="group -m-2 flex items-center p-2"
                    >
                      <UserCircleIcon
                        className="h-6 w-6 flex-shrink-0  text-white hover:text-blue-400"
                        aria-hidden="true"
                      />
                      {/* <span className="ml-2 rtl:mr-2 text-sm font-medium  text-white">
                      {cartFull === 0
                        ? localStorage.getItem("CountCart")
                        : cartFull}
                    </span> */}
                      <span className="sr-only">items in cart, view bag</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden">
              <div className="space-y-1 px-2 pb-3 pt-2">
                {navigation.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as="a"
                    // href={item.href}
                    onClick={async () => {
                      navigate(`${item.href}`);
                    }}
                    className={classNames(
                      path === item.href
                        ? "bg-gray-900 text-white"
                        : "text-gray-300 hover:bg-gray-700 hover:text-white",
                      "block rounded-md px-3  py-2 text-base font-medium "
                    )}
                    aria-current={path === item.href ? "page" : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}

                <div
                  onClick={() => changeLanguage(lang)}
                  className=" text-white block rounded-md px-3 py-2 text-base font-medium "
                >
                  <button
                    // onClick={}
                    className="-m-2 flex items-center p-2 "
                  >
                    <img
                      src={
                        lang === "rtl"
                          ? "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
                          : "https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg"
                      }
                      alt=""
                      className="block h-auto w-5 flex-shrink-0"
                    />
                    <span className="ml-3 rtl:mr-3 block text-base font-medium text-white">
                      {t("lang")}
                    </span>
                    <span className="sr-only">, change currency</span>
                  </button>
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>{" "}
      <NotificationsNav title={`${t("emptyCart")}`} />
      <Search
        isSearch={isSearch}
        setIsSearch={setIsSearch}
        t={t}
        company={company}
      />
    </>
  );
}
